import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(ToastPlugin, {
    position: 'top-right',
    duration: 3000,
  });

  // Expose $toast to the NuxtApp
  return {
    provide: {
      toast: nuxtApp.vueApp.config.globalProperties.$toast
    }
  };
});
